import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Flame = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Symbols">
        <g id="Component/Card/Article/Article-Image-Title-Auth-Cat-Date-Duration-Hot--D">
          <g id="Group">
            <g id="Path">
              <path
                id="Vector"
                d="M9.72289 6.293C9.72289 6.293 10.4689 1.905 7.42489 0C7.33317 1.52486 6.59636 2.93848 5.39889 3.887C4.09889 5.03 1.65389 7.6 1.67989 10.34C1.66084 12.7293 2.99821 14.9227 5.13089 16C5.20635 14.9316 5.7088 13.9386 6.52489 13.245C7.2164 12.7132 7.66533 11.9259 7.77089 11.06C9.59143 12.0278 10.7689 13.8817 10.8709 15.941V15.954C12.883 15.0323 14.2076 13.0593 14.2989 10.848C14.5149 8.274 13.1049 4.774 11.8539 3.63C11.3816 4.68445 10.6481 5.601 9.72289 6.293Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Flame.displayName = 'Flame';
